"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeUndefinedFields = void 0;
const removeUndefinedFields = (object) => {
    if (!object)
        return undefined;
    return Object.keys(object).reduce((acc, key) => {
        return object[key] === undefined ? acc : { ...acc, [key]: object[key] };
    }, {});
};
exports.removeUndefinedFields = removeUndefinedFields;
